import React from 'react';
import './PropertyItem.css';

const PropertyItem = (props) => {
    return ( 
        <>
        <div className="propertyItem">
            <img src={props.itemIcon} alt="icon" />
            <span>{props.itemValue}</span>
        </div>
        </>
     );
}
 
export default PropertyItem;